module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "container mt-3"
  }, [_c('b-card', {
    staticClass: "text-center"
  }, [_c('b-row', {
    staticClass: "treasury-logo p-1",
    attrs: {
      "align-v": "end"
    }
  }, [_c('b-col', {
    attrs: {
      "cols": "2"
    }
  }, [_c('img', {
    staticClass: "p-1",
    attrs: {
      "src": require("@/assets/images/grb.svg")
    }
  })]), _vm._v(" "), _c('b-col', [_c('div', {
    staticClass: "p-2"
  }, [_c('label', [_vm._v("РЕПУБЛИКА СРБИЈА")]), _vm._v(" "), _c('label', [_vm._v("МИНИСТАРСТВО ФИНАНСИЈА")]), _vm._v(" "), _c('label', {
    staticClass: "heavy-text"
  }, [_vm._v("УПРАВА ЗА ТРЕЗОР")])])])], 1), _vm._v(" "), _c('h3', {
    staticClass: "mt-5 mb-3 heavier-text"
  }, [_vm._v("Централни регистар фактура")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "p-1"
  }, [_vm._v("\n            Министарство финансија спроводи мере и активности у вези са контролом преузетих обавеза у јавном сектору\n            што између осталог подразумева евидентирање, праћење и извештавање о неизмиреним обавезама.\n            За обављање поменутих активности успостављен је информациони систем под називом Централни регистар фактура (ЦРФ).\n            ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('b-card', {
    staticClass: "text-center",
    attrs: {
      "bg-variant": "warning",
      "text-variant": "white"
    }
  }, [_c('b-card-text', [_c('span', {
    staticClass: "heavier-text"
  }, [_c('b-link', {
    attrs: {
      "href": "https://www.trezor.gov.rs/files/services/crf/Obave%C5%A1tenje%20subjektima%20javnog%20sektora%20koji%20pla%C4%87anja%20vr%C5%A1e%20preko%20ra%C4%8Duna%20koji%20se%20vode%20kod%20banaka%20-%2019.05.2026.%20godine.pdf"
    }
  }, [_vm._v("Обавештење субјектима јавног сектора који плаћање врше преко рачуна који се воде код банака")])], 1)])], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "heavier-text",
    staticStyle: {
      "color": "#aaaaaa"
    }
  }, [_vm._v(" Погледајте "), _c('a', {
    staticStyle: {
      "color": "gray"
    },
    attrs: {
      "href": "/docs/user/register"
    }
  }, [_vm._v("документацију за регистровање")]), _vm._v(" правног лица")])], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('b-row', {
    staticClass: "mt-3 heavier-text",
    attrs: {
      "align-h": "center"
    }
  }, [_c('a', {
    attrs: {
      "href": _vm.changelogPath
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('general.changelog')))])])]), _vm._v(" "), _c('b-row', {
    staticClass: "mt-5 heavier-text",
    attrs: {
      "align-h": "center"
    }
  }, [_c('a', {
    attrs: {
      "href": _vm.supportPath
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('general.technicalSupport')))])])])], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-5c8ae859", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5c8ae859","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href","b-img":"src"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/StartPage.vue
// module id = 787
// module chunks = 1